import Base from './Base'
import Home from './Home'
import Producto from './Producto'
import Nosotros from './Nosotros'
import Contacto from './Contacto'
import Blog from './Blog'
import Single from './Single'
import Legales from './Legales'
// //cambio: renderer para template Hub Educativo (page-pilar.php)
import Educativo from './Educativo'
// import Garantias from './Garantias'
// import CuentaCorriente from './CuentaCorriente'
// import Pymes from './Pymes'
// import Detail from './Detail'
// import Elegirnos from './Elegirnos'
// import Financiamiento from './Financiamiento'
// import Contacto from './Contacto'
// import QuienesSomos from './QuienesSomos'
// import Talento from './Talento'
// import Historias from './Historias'
// import Legales from './Legales'
// import Leasing from './Leasing'
// import Mercado from './mercado'
// import Colocaciones from './Colocaciones'
// import Resumen from './Resumen'

export {
    Base,
    Home,
    Producto,
    Nosotros,
    Contacto,
    Blog,
    Single,
    Legales,
    Educativo
}